module.exports = __webpack_public_path__ + "img/20200515_164137.0e64eada.jpg";